export default __webpack_public_path__ + "static/02-02-writing-note-taking-4b4c72d04e3bed28c8a38cf22097f75f.mp4";